import { Component, inject, HostBinding } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-toasts',
  template: `
    <ng-container *ngFor="let toast of toastService.toasts; trackBy: trackToast">
      <ngb-toast
        [class]="toast.classname"
        [autohide]="true"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
      >
        <ng-template [ngTemplateOutlet]="toast.template"></ng-template>
      </ngb-toast>
    </ng-container>
  `,
})
export class ToastsContainerComponent {
  @HostBinding('class') hostClass = 'toast-container position-fixed bottom-0 end-0 p-3';
  @HostBinding('style.z-index') hostZIndex = '1200';

  toastService = inject(ToastService);

  trackToast(index: number, toast: any) {
    return toast.id;
  }
}
